<template>
  <div class="btn-menu">
	  	<div @click="$emit('open')" class="open" v-if="!$parent.infoOpen">
			<help-icon class="help"/>
		</div>
	  	<div @click="$emit('close')" class="close" v-if="$parent.infoOpen">
			<close-icon/>
		</div>
  </div>
</template>

<script>

import HelpIcon from './icons/interro.svg';
import CloseIcon from './icons/croix-fermer.svg';

export default {
	name: 'MenuButtonControl',
	components: {
		HelpIcon,
		CloseIcon,
	},
}
</script>


<style scoped lang="scss">

.btn-menu {
	@include base-circle() {
		background-color: $bg-box;
		line-height:0;
		width: 42px;
		height: 42px;

		* {
			fill: #fff;
			transform-origin: center;
		}

	}
}

.close {
	* {
		transform: scale(.6);
	}
}


.help {
	transform: scale(.36) translateY(-5px);
}
</style>
